import { Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaModal from "../Items/Modal/Index";
import NetwalaSelect from "../Items/Select/Index";
import "./styles/RequestIPTVModal.css";
const AssignTicketToStaffModal: React.FC<IAssignTicketToStaffModalProps> = ({
  show,
  handleClose,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const [staffs, setStaffs] = useState<StaffListType[]>([]);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>("auth/getMyStaffMini");
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      const filteredData = data.filter(
        (staff: StaffListType) => staff.headType !== "PANEL_MANAGER"
      );
      setStaffs(filteredData || []);
    }
  }, [apiResponse]);
  useEffect(() => {
    postApiData({});
  }, []);

  const onFinish = (values: any) => {
    const { staff } = values;
    handleClose(true, staff);
  };
  const onFinishFailed = (errorInfo: any) => {};

  return (
    <>
      <NetwalaModal
        title="Assign Complaint to Staff"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => handleClose(false, null)}
      >
        {contextHolder}

        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="assignTicketToStaffForm"
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">Choose Staff</span>
                }
                name="staff"
                rules={[
                  {
                    required: true,
                    message: "Please Choose Staff",
                  },
                ]}
              >
                <NetwalaSelect
                  showSearch
                  size="large"
                  height="45px"
                  options={staffs.map((staff) => ({
                    label: staff.firstName + " " + staff.lastName,
                    value: staff.intPkHeadID,
                  }))}
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.YELLOW}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Assign Complaint to Staff"
                  borderColor="#FFA726"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default AssignTicketToStaffModal;
